import React, { useEffect, useState } from 'react'
import CustomerModel from './models/CustomerModel';

function ViewCustomer(props) {
  const [customerData, setCustomerData] = useState(new CustomerModel());

  useEffect(() => {
    setCustomerData(props.CustomerData);
  }, [props.CustomerData])
  return (
    <>
      <div className="row">
        <div className="mb-3 add-product">
          <label className="form-label">Customer Name</label>
          <input type="text" className="form-control" value={customerData.CustomerName ?? ""} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">Mobile</label>
          <input type="text" className="form-control" value={customerData.MobileNumber ?? ""} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">Email</label>
          <input type="text" className="form-control" value={customerData.EmailId ?? ""} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">Address</label>
          <textarea className="form-control h-100" rows="3" value={`${customerData.AddressLine1 ?? ""}\n${customerData.AddressLine2 ?? ""}\n${customerData.AddressLine3 ?? ""}`} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">City</label>
          <input type="text" className="form-control" value={customerData.City ?? ""} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">State</label>
          <input type="text" className="form-control" value={customerData.State ?? ""} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">Country</label>
          <input type="text" className="form-control" value={customerData.Country ?? ""} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">Pin</label>
          <input type="text" className="form-control" value={customerData.PinNumber ?? ""} disabled />
        </div>
      </div>
    </>
  )
}

export default ViewCustomer